import VueLib from 'vue'
import merge from 'lodash.mergewith'
import * as Sentry from '@sentry/browser'

// eslint-disable-next-line require-await
export default async function (ctx, inject) {
  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
